import tokens from '@ifood/pomodoro-tokens';
import styled from 'styled-components';

import { MAX_CONTENT_WIDTH } from 'modules/UI';

import NavBar from '../NavBar';

export const Container = styled.div`
  position: sticky;
  top: 0;
  z-index: 2;

  @media (max-width: ${tokens.breakpoints.s}) {
    display: none;
  }
`;

export const Header = styled.header`
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: ${tokens.colors.white};
  padding: 0 ${tokens.space.regular};
  box-sizing: border-box;
  height: 80px;
  border-bottom: 1px solid ${tokens.colors.gray};
`;

export const Content = styled.div`
  display: flex;
  align-items: center;
  box-sizing: border-box;
  width: 100%;
  max-width: ${MAX_CONTENT_WIDTH};
`;

export const LogoSpacer = styled.div`
  width: 100%;
  flex-shrink: 1;
  max-width: 66px;
`;

export const NavSpacer = styled.div`
  width: 100%;
  flex-shrink: 1;
`;

export const NavLinks = styled(NavBar)`
  font-family: ${tokens.font.family.ifood.body};
  font-size: ${tokens.fontSizes.s};
  line-height: ${tokens.lineHeights.m};
  height: 50px;
  display: grid;
  grid-gap: 43px;
  grid-auto-flow: column;
  align-items: center;
`;
